import { Circle as CircleStyle, Fill, Icon, Stroke, Style, Text } from 'ol/style';
import { Point } from 'ol/geom';
import { toLonLat } from 'ol/proj';
import { getDistance } from 'ol/sphere';
import calculateSpeed from '../../../utils/calculateSpeed';

export const vectorStyle = (props = {}) => {
  const {
    strokeColor = '#0e97fa',
    strokeWidth = 4,
    fillColor = 'rgba(0, 153, 255, 0.2)',
    label = '',
    isCenterText = false,
  } = props;

  const polygonStyle = new Style({
    stroke: new Stroke({ color: strokeColor, width: strokeWidth }),
    fill: new Fill({ color: fillColor, rule: 'evenodd' }),
    image: new CircleStyle({
      radius: 9,
      fill: new Fill({ color: [0, 153, 255, 1] }),
      stroke: new Stroke({ color: [255, 255, 255, 1], width: 5 }),
    }),
  });

  const textStyle = new Style({
    text: new Text({
      font: '14px roboto',
      text: label,
      fill: new Fill({ color: 'black' }),
      stroke: new Stroke({ color: 'white', width: 3 }),
    }),
    geometry(feature) {
      const geometry = feature.getGeometry();
      if (isCenterText && geometry.getInteriorPoint) {
        // точка внутри полигона для подписи по центру
        return geometry.getInteriorPoint();
      }
      // иначе первая точка контура
      const coords = geometry.getCoordinates()[0];
      if (!coords || coords.length === 0) return null;
      return new Point(coords[0]);
    },
  });

  return [polygonStyle, textStyle];
};

export function addHoleToPolygonGeometry(polyGeom, holeCoords) {
  if (!polyGeom || polyGeom.getType() !== 'Polygon') return false;

  const coords = polyGeom.getCoordinates();
  if (!Array.isArray(coords) || !Array.isArray(holeCoords)) return false;

  if (holeCoords.length < 4) return false;

  coords.push(holeCoords);
  polyGeom.setCoordinates(coords);

  return true;
}

export const safeParseTime = (t) => {
  const v = Date.parse(t);
  return Number.isNaN(v) ? 0 : v;
};

export const distanceBetween = (a, b) => {
  const p1 = toLonLat(a);
  const p2 = toLonLat(b);

  return getDistance(p1, p2);
};

export const calcSpeedKmh = (p1, p2) => {
  if (!p1?.coordinates || !p2?.coordinates) return 0;

  const [lon1, lat1] = toLonLat(p1.coordinates);
  const [lon2, lat2] = toLonLat(p2.coordinates);

  return calculateSpeed(lat1 * 1e7, lon1 * 1e7, p1.date, lat2 * 1e7, lon2 * 1e7, p2.date);
};

export const customVehicleStyle = (
  vehicleIconBase64,
  text,
  opacity,
  icoColor = '#2a547c',
  vehicleColor = '#000000',
) => {
  if (!vehicleIconBase64) return null;

  const filterId = `colorFilter_${vehicleColor.replace('#', '')}`;

  // фильтры для задания цвета иконке ТС
  const colorFilter = `
    <filter id="${filterId}" color-interpolation-filters="sRGB">
      <feFlood flood-color="${vehicleColor}" result="flood"/>
      <feComposite in="flood" in2="SourceAlpha" operator="in"/>
    </filter>
  `;

  // SVG маркера карты, внутри цветная иконка ТС
  const compositeSvg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="50" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>${colorFilter}</defs>
      <circle cx="20" cy="25" r="14" fill="white" stroke="${icoColor}" stroke-width="3.5"/>
      <image x="10" y="15" width="20" height="20" preserveAspectRatio="xMidYMid meet" xlink:href="${vehicleIconBase64}" filter="url(#${filterId})"/>
      <polygon points="20,50 14,40 26,40" fill="${icoColor}"/>
    </svg>
  `;

  // eslint-disable-next-line
  const compositeSvgUrl = 'data:image/svg+xml;base64,' + btoa(compositeSvg);

  return new Style({
    image: new Icon({
      src: compositeSvgUrl,
      scale: 1,
      anchor: [0.5, 1],
      opacity,
    }),
    text: new Text({
      text: text || '',
      font: '14px roboto',
      overflow: true,
      fill: new Fill({ color: 'black' }),
      stroke: new Stroke({ color: 'white', width: 3 }),
      offsetY: -48,
    }),
  });
};
